import { render, staticRenderFns } from "./AddressActionDelete.vue?vue&type=template&id=7c89bd7d&"
import script from "./AddressActionDelete.vue?vue&type=script&lang=ts&"
export * from "./AddressActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports